// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../images/whyaxisma.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Why{
    text-align: left;
    margin-top: 30px;
    color: #000;
    font-size: 36px;
    margin-bottom: 20px;
}
.why-axima-container .card-title , .why-axima-selling-process h3 {

    font-size: 30px;
}
.why-axima-selling-process h3::before ,.why-axima-container .card-title::before {
    content: "";
    border-left: 5px solid #ff5800;
    padding-left: 15px;
}
.why-axima-container .card-body p {
    font-size: 18px;
}
.why-axima-container ul {
    padding-left: 10px;
    list-style: none;
}
.why-axima-container ul li {
    font-size: 18px;
    padding-bottom: 15px;
}
.why-axima-container ul li::before {
    content: "\\276F";
    color: red;
    font-weight: 500;
    display: inline-block;
    width: 1em;
    margin-left: -1em;
}
.why-axima-selling-process {
    background: #f5f5f5;
    padding: 40px 0;
}
.why-axima-selling-process ol {
    list-style: none;
     counter-reset: li;
     margin-bottom: 30px;
    }
.why-axima-selling-process li {
    counter-increment: li;
    font-size: 18px;
    margin-bottom: 15px;
}

.list_heading{
    color: #ff5800;
}

.why-axima-selling-process ol li::before {
    content: counter(li); 
    color: red;
    display: inline-block; 
    width: 1em; 
    margin-left: -1.5em;
    margin-right: 0.5em; 
    text-align: right; 
    direction: rtl}
.WhyAxis-bold b{
    font-weight: 500;
    font-size:25px; 
}
.WhyAxis-bold{
    margin-bottom: 10px;
    margin-top: 20px;
}
.WhyAxis-border{
    border: 1px solid black;
    width: 65px;
    
}
.WhyAxis-cap{
    margin-left: 20%;
    margin-right: 20%;
}
.WhyAxis-subclass{
    color: blue;
    font-size: 20px;
    margin-bottom: 10px;
    margin-top: 10px;
}
.WhyAxis-para{
    text-align: justify;
    margin-bottom: 40px!important;
    line-height: 30px;
}
.WhyAxis-caption{
    margin-top: 15px;
    font-weight: bold;
    margin-left: 35px;
    padding-bottom: 10px;
}
.WhyAxis-li li{
    margin-left: 70px;
    background:url(${___CSS_LOADER_URL_REPLACEMENT_0___})left bottom no-repeat;
    list-style:none;
    padding-left: 40px;
    /* list-style-position: inside; */
    margin-bottom: 10px;
    
}

.WhyAxis-li1 li{
    margin-left: 70px;
    background:url(${___CSS_LOADER_URL_REPLACEMENT_0___})left bottom no-repeat;
    list-style:none;
    padding-left: 40px;
    /* list-style-position: inside; */
    margin-bottom: 10px;
}
.WhyAxis-subclass-1{
    color: blue;
    font-size: 20px;
    margin-top: 25px;
}
.WhyAxis-ol ol li{
    line-height: 33px;
}
.WhyAxis-bold-1{
    margin-top: 20px;
    margin-bottom: 20px;
}
.WhyAxis-subclass-2{
    color: blue;
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
}
    /* .WhyAxis-img{
        height: 270px;

    } */


@media (max-width: 768px){
.WhyAxis-cap {
    margin-left: 10%;
    margin-right: 10%;
}
}
@media (max-width: 575.98px) {
    .why-axima-container .card-title, .why-axima-selling-process h3 {
        font-size: 21px;
    }
    .Why {
        font-size: 28px;
        margin-bottom: 0;
    }
    .why-axima-container .card-body p {
        font-size: 17px;
    }
    .card, .buy_side_representation_header {
        margin-bottom: 0 !important;
    }
    .why-axima-container ul {
        margin-bottom: 0;
    }
}
@media (max-width:  991.98px){
    .WhyAxis-img{
        width: 100%;
    }
    .WhyAxis-img-sell{
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/WhyAxis/Whyaxis.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;KACf,iBAAiB;KACjB,mBAAmB;IACpB;AACJ;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,qBAAqB;IACrB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;IACI,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,WAAW;;AAEf;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,uEAAqE;IACrE,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;;AAEvB;;AAEA;IACI,iBAAiB;IACjB,uEAAqE;IACrE,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;IACI;;;OAGG;;;AAGP;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".Why{\n    text-align: left;\n    margin-top: 30px;\n    color: #000;\n    font-size: 36px;\n    margin-bottom: 20px;\n}\n.why-axima-container .card-title , .why-axima-selling-process h3 {\n\n    font-size: 30px;\n}\n.why-axima-selling-process h3::before ,.why-axima-container .card-title::before {\n    content: \"\";\n    border-left: 5px solid #ff5800;\n    padding-left: 15px;\n}\n.why-axima-container .card-body p {\n    font-size: 18px;\n}\n.why-axima-container ul {\n    padding-left: 10px;\n    list-style: none;\n}\n.why-axima-container ul li {\n    font-size: 18px;\n    padding-bottom: 15px;\n}\n.why-axima-container ul li::before {\n    content: \"\\276F\";\n    color: red;\n    font-weight: 500;\n    display: inline-block;\n    width: 1em;\n    margin-left: -1em;\n}\n.why-axima-selling-process {\n    background: #f5f5f5;\n    padding: 40px 0;\n}\n.why-axima-selling-process ol {\n    list-style: none;\n     counter-reset: li;\n     margin-bottom: 30px;\n    }\n.why-axima-selling-process li {\n    counter-increment: li;\n    font-size: 18px;\n    margin-bottom: 15px;\n}\n\n.list_heading{\n    color: #ff5800;\n}\n\n.why-axima-selling-process ol li::before {\n    content: counter(li); \n    color: red;\n    display: inline-block; \n    width: 1em; \n    margin-left: -1.5em;\n    margin-right: 0.5em; \n    text-align: right; \n    direction: rtl}\n.WhyAxis-bold b{\n    font-weight: 500;\n    font-size:25px; \n}\n.WhyAxis-bold{\n    margin-bottom: 10px;\n    margin-top: 20px;\n}\n.WhyAxis-border{\n    border: 1px solid black;\n    width: 65px;\n    \n}\n.WhyAxis-cap{\n    margin-left: 20%;\n    margin-right: 20%;\n}\n.WhyAxis-subclass{\n    color: blue;\n    font-size: 20px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n}\n.WhyAxis-para{\n    text-align: justify;\n    margin-bottom: 40px!important;\n    line-height: 30px;\n}\n.WhyAxis-caption{\n    margin-top: 15px;\n    font-weight: bold;\n    margin-left: 35px;\n    padding-bottom: 10px;\n}\n.WhyAxis-li li{\n    margin-left: 70px;\n    background:url(../../../../images/whyaxisma.png)left bottom no-repeat;\n    list-style:none;\n    padding-left: 40px;\n    /* list-style-position: inside; */\n    margin-bottom: 10px;\n    \n}\n\n.WhyAxis-li1 li{\n    margin-left: 70px;\n    background:url(../../../../images/whyaxisma.png)left bottom no-repeat;\n    list-style:none;\n    padding-left: 40px;\n    /* list-style-position: inside; */\n    margin-bottom: 10px;\n}\n.WhyAxis-subclass-1{\n    color: blue;\n    font-size: 20px;\n    margin-top: 25px;\n}\n.WhyAxis-ol ol li{\n    line-height: 33px;\n}\n.WhyAxis-bold-1{\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n.WhyAxis-subclass-2{\n    color: blue;\n    font-size: 20px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n    /* .WhyAxis-img{\n        height: 270px;\n\n    } */\n\n\n@media (max-width: 768px){\n.WhyAxis-cap {\n    margin-left: 10%;\n    margin-right: 10%;\n}\n}\n@media (max-width: 575.98px) {\n    .why-axima-container .card-title, .why-axima-selling-process h3 {\n        font-size: 21px;\n    }\n    .Why {\n        font-size: 28px;\n        margin-bottom: 0;\n    }\n    .why-axima-container .card-body p {\n        font-size: 17px;\n    }\n    .card, .buy_side_representation_header {\n        margin-bottom: 0 !important;\n    }\n    .why-axima-container ul {\n        margin-bottom: 0;\n    }\n}\n@media (max-width:  991.98px){\n    .WhyAxis-img{\n        width: 100%;\n    }\n    .WhyAxis-img-sell{\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
